<template>
  <section class="container items-container">
    <div class="row">
      <div class="col-12 col-md-4" v-for="card in cardList">
        <Cards :title="card.title" :icon="card.icon" :url="card.url"></Cards>
      </div>
      <!-- /.col-12 col-md-4 -->
    </div>
    <!-- /.row -->
  </section>
  <!--== /.container ==-->
</template>

<script>
  import Cards from './home/Cards.vue';

  import GestaoGovernacaImg from '../assets/images/icons/gestao-e-governanca.jpg';
  import GestaoPessoasImg from '../assets/images/icons/gestao-pessoas.jpg';
  import GestaoOrcamentosImg from '../assets/images/icons/orcamento-e-financas.jpg';

  export default {
    name: 'Items',
    data () {
      return {
        cardList: [
          {
            title: 'Gestão e Governança',
            icon: GestaoGovernacaImg,
            url: 'gestaoegovernanca'
          },
          {
            title: 'Gestão de Pessoas',
            icon: GestaoPessoasImg,
            url: 'gestaodepessoas'
          },
          {
            title: 'Orçamentos e Finanças',
            icon: GestaoOrcamentosImg,
            url: 'orcamentosefinancas'
          }
        ]
      }
    },

    components: {
      Cards
    }
  };
</script>

<style scoped lang="scss">
  .items-container {
    margin-top: 30px;
  }
</style>
